import React from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { Bar } from "react-chartjs-2";
import ChartState from "./_shared/ChartState";
import { ACCENT, barOptions } from "./_shared/chartTheme";

const TOP_N = 8;

const DiamondReportsCertificateComp = ({ data, loading }) => {
  const { t } = useTranslation();
  const list = data || [];

  const filtered = list.filter((item) => item.CNT > 0);
  const sorted = [...filtered].sort((a, b) => b.CNT - a.CNT);
  const top = sorted.slice(0, TOP_N);
  const rest = sorted.slice(TOP_N);
  const othersTotal = rest.reduce((sum, item) => sum + item.CNT, 0);
  const rows =
    othersTotal > 0
      ? [...top, { Certificate: t("Others"), CNT: othersTotal }]
      : top;

  const chartJsData = {
    labels: rows.map((item) => item.Certificate),
    datasets: [
      {
        label: t("Count"),
        data: rows.map((item) => item.CNT),
        backgroundColor: ACCENT,
        borderRadius: 4,
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <label>
          <b> {t("Diamond Certificate Searches")} </b>
        </label>
        <div className="chart__section">
          <Spin spinning={loading} size="large">
            {rows.length > 0 ? (
              <div className="edr-chartwrap edr-tall">
                <Bar data={chartJsData} options={barOptions(true)} />
              </div>
            ) : (
              <ChartState loading={loading} />
            )}
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsCertificateComp;
